export enum Climate {
    MILD_CLIMATE = "mild",
    HOT_CLIMATE = "hot",
    COLD_CLIMATE = "cold",
}